import * as React from "react";
import { useTheme } from "@mui/material";
import { NumericalKey } from "../../../Utils/utilityTypes";
import { aggregateNumericalField } from "../../../Utils/numbers";
import { colorShade } from "./KendoReactColoredFooterCell";

type KendoReactDataGridFooterSumCellProps<T> = {
  items?: T[];
  fieldKey: NumericalKey<T>;
};
export const KendoReactDataGridFooterSumCell = <T,>({
  items,
  fieldKey,
}: KendoReactDataGridFooterSumCellProps<T>) => {
  const theme = useTheme();

  const total = aggregateNumericalField({ items, fieldKey });

  return <td style={{ backgroundColor: theme.palette.grey[colorShade] }}>{total}</td>;
};
